<template>
  <div
    class="roles"
    v-if="roles.length > 0"
  >
    <span
      v-for="item in roles"
      :key="`roles-${item.id}`"
    >
      <a-popconfirm
        :style="disabled ? { cursor: 'not-allowed' } : {}"
        :disabled="disabled"
        :title="'roles.quest' | globalize"
        :ok-text="'roles.answer-yes' | globalize"
        :cancel-text="'roles.answer-no' | globalize"
        @confirm="() => onSelectRole(item)">
        <a-tag
          :class="getСolor(item)"
          :title="item.description"
        >
          {{ item.name }}
        </a-tag>
      </a-popconfirm>
    </span>
  </div>
</template>

<script>
import ATag from 'ant-design-vue/lib/tag'
import APopConfirm from 'ant-design-vue/lib/popconfirm'

export default {
  name: 'roles',
  components: {
    ATag,
    'a-popconfirm': APopConfirm,
  },
  props: {
    onClick: {
      type: Function,
      default: () => {},
      required: true,
    },
    roles: {
      type: Array,
      default: () => [],
      required: true,
    },
    role: {
      type: Object,
      default: () => {},
      required: true,
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
  },
  data () {
    return {
      selectedItem: {},
    }
  },
  created () {
    this.selectedItem = this.role
  },
  methods: {
    getСolor (item) {
      if (item.id === this.selectedItem.id) {
        return 'success'
      }
      return 'default'
    },
    onSelectRole (item) {
      this.selectedItem = item
      return this.onClick(item)
    },
  },
}
</script>

<style lang="scss">
  @import '~ant-design-vue/lib/tag/style/index.css';
  @import '~ant-design-vue/lib/popover/style/index.css';
  @import '~@scss/variables';

  .roles .ant-tag {
    color: $_black;
    cursor: pointer;
  }

  .roles .default {
    background: $_lightGray;
  }

  .roles .success {
    background: $_lightGreen;
  }
</style>
